import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { MemberDataCaptureLayout } from 'Organisms/MemberDataCapture/MemberDataCaptureLayout';

export default function MemberDataCaptureContainer({ link }) {
  const {
    collection, setCollection, isInitializing, loadingError,
  } = useLink(link);
  const resource = collection?.resources().head();

  return (
    <DataContainer
      component={MemberDataCaptureLayout}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        resource,
        setPage: setCollection,
      }}
    />
  );
}
MemberDataCaptureContainer.propTypes = {
  link: PropTypes.instanceOf(fr.Link).isRequired,
};
